<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 7.4083332 7.4083335" version="1.1" id="svg8" @click="$emit('click')">
		<g inkscape:label="Capa 1" inkscape:groupmode="layer" id="layer1" transform="translate(0,-289.59165)">
			<g id="g3727" transform="matrix(0.21154703,0,0,0.19998395,87.378041,52.028242)" style="fill:none;fill-rule:evenodd">
				<g id="g3725">
					<g id="g3723" style="fill:none;fill-rule:nonzero" transform="matrix(2.1012503,0,0,2.1012503,-408.93768,-254.09734)">
						<g id="g3721" transform="translate(-1.1273687,687.38771)">
							<circle id="circle3715" r="7.5" cy="7.5" cx="7.5" style="stroke:#487fff"/>
							<g id="g3719" style="fill:#487fff">
								<path id="path3717" transform="translate(3.6,4.2)" d="M 6.487,0.563 2.884,4.1 1.907,3.14 C 1.55,2.79 0.972,2.79 0.615,3.14 0.259,3.49 0.259,4.058 0.615,4.408 L 2.24,6.003 c 0.178,0.175 0.412,0.263 0.645,0.263 0.234,0 0.468,-0.088 0.646,-0.263 L 7.779,1.831 c 0.357,-0.35 0.357,-0.918 0,-1.268 -0.356,-0.35 -0.935,-0.35 -1.291,0 z" inkscape:connector-curvature="0"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'check-icon-outlined',
	props: ['primary'],
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/shared/components/icons/check-icon-outlined.vue